import React from "react";
import Text from "@streeteasy/design-system/deprecated/Text";
import { camelCase, mapKeys } from "lodash";
import { func, shape, string } from "prop-types";

import { shareConfirmationGA } from "../../../../analytics/ga";
import executeRouteLogin from "../../../../helpers/executeRouteLogin";
import getCurrentUser from "../../../../helpers/getCurrentUser";
import { TextBold } from "../../styled";
import AccountCreatedConfirmation from "./confirmations/AccountCreatedConfirmation";
import BlankConfirmation from "./confirmations/BlankConfirmation";
import LoggedInUserConfirmation from "./confirmations/LoggedInUserConfirmation";
import PasswordRequestedConfirmation from "./confirmations/PasswordRequestedConfirmation";
import PasswordRequiredToRegisterConfirmation from "./confirmations/PasswordRequiredToRegisterConfirmation";
import SSOUserConfirmation from "./confirmations/SSOUserConfirmation";
import VerificationSentConfirmation from "./confirmations/VerificationSentConfirmation";

class ShareConfirmation extends React.Component {
  state = { confirmationContentKey: "DefaultContent", ssoUrl: "" };

  componentDidMount() {
    this.initConfirmation();
  }

  getContent = () => {
    const confirmationMapping = {
      AccountCreated: AccountCreatedConfirmation,
      DefaultContent: BlankConfirmation,
      LoggedInUser: LoggedInUserConfirmation,
      PasswordRequested: PasswordRequestedConfirmation,
      PasswordRequiredToRegister: PasswordRequiredToRegisterConfirmation,
      SSOUser: SSOUserConfirmation,
      VerificationSent: VerificationSentConfirmation
    };
    const confirmationProps = {
      data: {
        confirmationText: this.textWithBold(this.props.data.confirmationText),
        email: this.props.data.email,
        origin: "share",
        sharedType: this.props.data.sharedType,
        ssoUrl: this.state.ssoUrl
      },
      setScenario: this.props.setScenario,
      scenario: this.props.scenario
    };
    const Content = confirmationMapping[this.state.confirmationContentKey];

    return <Content {...confirmationProps} />;
  };

  textWithBold = text => {
    const matches = text.match(/(.*)<b>(.*)<\/b>(.*)/);

    if (matches) {
      return (
        <Text type="sm">
          {matches[1]}
          <TextBold as="span" type="sm">
            {matches[2]}
          </TextBold>
          {matches[3]}
        </Text>
      );
    }

    return <Text type="sm">{text}</Text>;
  };

  handleCompleted = data => {
    // GA starts
    const analyticsData = mapKeys(
      data.route_login.analytics_data,
      (value, key) => camelCase(key)
    );

    analyticsData.source = "share";
    localStorage.setItem("analytics", JSON.stringify(analyticsData));
    shareConfirmationGA.shareConfirmationModalOpen(analyticsData.flow);

    if (data.route_login.__typename === "AccountCreated")
      shareConfirmationGA.accountIsCreated(analyticsData.flow);
    // GA ends
  };

  initConfirmation = async () => {
    const loggedInUser = await getCurrentUser();

    if (loggedInUser) {
      this.setState({ confirmationContentKey: "LoggedInUser" });
      return false;
    }

    this.triggerRouteLogin();

    return false;
  };

  triggerRouteLogin = async () => {
    const routeLoginResult = await executeRouteLogin(
      this.props.data.email,
      "share",
      JSON.stringify(this.props.data.itemInfo)
    );

    this.handleCompleted(routeLoginResult.data);
    this.props.onRouteLoginCompleted();
    this.setState({
      confirmationContentKey: routeLoginResult.data.route_login.__typename,
      ssoUrl: routeLoginResult.data.route_login.url
    });
  };

  render() {
    return this.getContent();
  }
}

ShareConfirmation.propTypes = {
  data: shape({
    confirmationText: string.isRequired,
    email: string.isRequired,
    origin: string.isRequired,
    sharedType: string.isRequired
  }).isRequired,
  onRouteLoginCompleted: func.isRequired,
  scenario: string.isRequired,
  setScenario: func.isRequired
};

export default ShareConfirmation;
